import { render, staticRenderFns } from "./Translations.vue?vue&type=template&id=7a0e3c42"
import script from "./Translations.vue?vue&type=script&lang=js"
export * from "./Translations.vue?vue&type=script&lang=js"
import style0 from "./Translations.vue?vue&type=style&index=0&id=7a0e3c42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports